(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    /* ---- 戻る操作時はカードの出現アニメーションを無効化 ---- */
  (function(){
    // 一度だけ実行
    if (window.pcScrollOptRun) return;
    window.pcScrollOptRun = true;

    var isBack = false;
    if (window.performance && window.performance.getEntriesByType) {
      var nav = window.performance.getEntriesByType('navigation')[0];
      if (nav && (nav.type === 'back_forward' || nav.type === 'back')) isBack = true;
    } else if (window.performance && window.performance.navigation) {
      if (window.performance.navigation.type === 2) isBack = true;
    }

    // 戻る操作の場合、強力な無効化CSSをヘッダーに注入
    if (isBack) {
      var style = document.createElement('style');
      style.innerHTML = `
        .pc-scroll-animate-target {
          opacity: 1 !important;
          visibility: visible !important;
          filter: none !important;
          backdrop-filter: none !important;
          -webkit-backdrop-filter: none !important;
          transform: none !important;
          transition: none !important;
          animation: none !important;
          will-change: auto !important;
        }
        .product-grid-view-zoom-out--details {
          opacity: 1 !important;
          visibility: visible !important;
          transform: none !important;
        }
        .product-card__media-bg-wrapper::before {
          opacity: 0 !important;
        }
        .product-card__media-bg-wrapper .pc-carousel-track {
          opacity: 1 !important;
        }
        .product-card__media-bg-wrapper .product-card__swatches-wrapper {
          opacity: 1 !important;
        }
        /* 戻る際はインジケーターのアニメーションも切る */
        .pc-indicator-segment, .pc-segmented-indicators-track {
          transition: none !important;
        }
      `;
      document.head.appendChild(style);
      document.documentElement.classList.add('is-back-navigation');
    }
  })();

  /* ---- カード本体（カルーセル / スウォッチ / 遅延読み込み） ---- */
  (function() {
    function normalize(val) { return String(val || '').toLowerCase().trim(); }
    const CARD_SELECTOR = '.product-card__media-bg-wrapper';
    const TRACK_SELECTOR = '.pc-carousel-track';
    const CARD_NAV_SELECTOR = '.pc-product-card-transition[data-product-url]';
    const SCROLL_TARGET_SELECTOR = '.pc-scroll-animate-target:not(.is-visible)';
    const CLICK_BLOCKER_SELECTOR = '.pc-click-blocker';
    const REINIT_TRIGGER_SELECTOR = '.product-card__media-bg-wrapper, .pc-carousel-track, .pc-click-blocker, .pc-scroll-animate-target';

    const initQueue = new Set();
    const activeTracks = new Set();
    let initQueued = false;
    let scrollObserver = null;
    let mediaObserver = null;
    let carouselInitObserver = null;
    let carouselVisibilityObserver = null;
    let resizeBound = false;
    let resizeTicking = false;

    function isSmallViewport() {
      return !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
    }

    function collect(root, selector) {
      const scope = root && typeof root.querySelectorAll === 'function' ? root : document;
      const nodes = Array.from(scope.querySelectorAll(selector));
      if (scope.nodeType === 1 && typeof scope.matches === 'function' && scope.matches(selector)) {
        nodes.unshift(scope);
      }
      return nodes;
    }

    function hasReinitTarget(node) {
      if (!node || node.nodeType !== 1) return false;
      if (typeof node.matches === 'function' && node.matches(REINIT_TRIGGER_SELECTOR)) return true;
      return !!(node.querySelector && node.querySelector(REINIT_TRIGGER_SELECTOR));
    }

    function queueInit(root) {
      const scope = root && typeof root.querySelectorAll === 'function' ? root : document;
      initQueue.add(scope);
      if (scope.nodeType === 1 && typeof scope.closest === 'function') {
        const parentCard = scope.closest(CARD_SELECTOR);
        if (parentCard) initQueue.add(parentCard);
      }

      if (initQueued) return;
      initQueued = true;

      const run = () => {
        initQueued = false;
        const roots = Array.from(initQueue);
        initQueue.clear();
        roots.forEach((queuedRoot) => initAll(queuedRoot));
      };

      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(run, { timeout: 300 });
      } else {
        setTimeout(run, 0);
      }
    }

    // CSS の scroll-behavior: smooth を一時的に無効にして、アニメーションなしで位置を合わせる。
    // （scrollTo({behavior:'auto'}) や scrollLeft 代入は CSS の smooth に従ってしまい、
    //   Safari では他のスクロールで中断されて先頭スライドに残ることがある）
    function scrollTrackInstant(track, left) {
      if (!track) return;
      const previous = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      void track.offsetWidth;
      track.scrollLeft = left;
      track.style.scrollBehavior = previous;
    }

    // いま選ばれているスライド（activeIndex、無ければ primary）に位置を合わせ直す
    function resyncTrack(track) {
      if (!track || track.children.length === 0) return;
      const activeIndex = parseInt(track.dataset.activeIndex || '-1', 10);
      let slide = activeIndex >= 0 ? track.children[activeIndex] : null;
      if (!slide) slide = getPrimarySlide(track);
      if (!slide) return;
      const targetLeft = slide.offsetLeft || 0;
      if (Math.abs(track.scrollLeft - targetLeft) > 1) {
        scrollTrackInstant(track, targetLeft);
      }
    }

    function markCardReady(card) {
      if (!card) return;
      const anchor = card.closest('.pc-media-price-anchor');
      if (anchor) anchor.classList.add('is-media-ready');
      if (card.dataset.mediaReady === 'true') return;
      card.dataset.mediaReady = 'true';
      card.classList.add('is-media-ready');
      card.setAttribute('aria-busy', 'false');
      // 表示状態になった直後にもう一度位置を合わせる（非表示中の scroll が反映されない環境への保険）
      const track = card.querySelector(TRACK_SELECTOR);
      if (track) window.requestAnimationFrame(() => resyncTrack(track));
    }

    function uniqueUrls(urls) {
      const seen = new Set();
      const result = [];
      (urls || []).forEach((rawUrl) => {
        const url = String(rawUrl || '').trim();
        if (!url || seen.has(url)) return;
        seen.add(url);
        result.push(url);
      });
      return result;
    }

    function addCacheBustParam(url, attempt) {
      if (!url || String(url).indexOf('data:') === 0) return url;
      const separator = url.indexOf('?') === -1 ? '?' : '&';
      return `${url}${separator}pc_retry=${attempt}`;
    }

    function readImageCandidates(img) {
      if (!img) return [];
      const dataCandidates = String(img.dataset.srcCandidates || '')
        .split('|')
        .map((item) => item.trim())
        .filter(Boolean);
      return uniqueUrls(
        dataCandidates.concat([
          img.dataset.src,
          img.dataset.fallbackSrc,
          img.currentSrc,
          img.getAttribute('src')
        ])
      );
    }

    function markImageLoaded(img, card) {
      if (!img) return;
      img.classList.remove('is-load-failed');
      img.classList.add('is-loaded');
      markCardReady(card);
    }

    function recoverImageLoad(img, card) {
      if (!img) return;
      const candidates = readImageCandidates(img);
      if (candidates.length === 0) {
        img.classList.add('is-load-failed', 'is-loaded');
        markCardReady(card);
        return;
      }

      const maxRetries = Math.max(parseInt(img.dataset.maxRetries || '6', 10), 1);
      let attempt = parseInt(img.dataset.loadAttempt || '0', 10);

      if (attempt >= maxRetries) {
        const fallback = img.dataset.fallbackSrc || candidates[candidates.length - 1];
        if (fallback && img.getAttribute('src') !== fallback) {
          img.setAttribute('src', fallback);
        }
        img.classList.add('is-load-failed', 'is-loaded');
        markCardReady(card);
        return;
      }

      const candidate = candidates[Math.min(attempt, candidates.length - 1)];
      attempt += 1;
      img.dataset.loadAttempt = String(attempt);

      if (img.dataset.srcset) {
        img.srcset = img.dataset.srcset;
      }
      if (img.dataset.sizes) {
        img.sizes = img.dataset.sizes;
      }

      const retrySrc = addCacheBustParam(candidate, attempt);
      if (img.getAttribute('src') === retrySrc) {
        const nextAttempt = attempt + 1;
        img.dataset.loadAttempt = String(nextAttempt);
        const nextCandidate = candidates[Math.min(nextAttempt - 1, candidates.length - 1)];
        img.setAttribute('src', addCacheBustParam(nextCandidate, nextAttempt));
      } else {
        img.setAttribute('src', retrySrc);
      }
    }

    function bindImageLoad(img, card) {
      if (!img) return;
      const targetCard = card || img.closest('.product-card__media-bg-wrapper');
      if (img.dataset.imageBound !== 'true') {
        img.dataset.imageBound = 'true';
        img.addEventListener('load', () => {
          if (img.naturalWidth > 0) {
            markImageLoaded(img, targetCard);
          } else {
            recoverImageLoad(img, targetCard);
          }
        });
        img.addEventListener('error', () => {
          recoverImageLoad(img, targetCard);
        });
      }

      if (img.complete) {
        if (img.naturalWidth > 0) {
          markImageLoaded(img, targetCard);
        } else {
          recoverImageLoad(img, targetCard);
        }
      }
    }

    function activateDeferredVideo(video) {
      if (!video || video.dataset.videoActivated === 'true') return;
      if (video.dataset.poster && !video.getAttribute('poster')) {
        video.setAttribute('poster', video.dataset.poster);
      }
      let hasDeferredSource = false;
      video.querySelectorAll('source[data-src]').forEach((source) => {
        if (source.getAttribute('src')) return;
        const deferredSrc = source.dataset.src;
        if (!deferredSrc) return;
        source.setAttribute('src', deferredSrc);
        hasDeferredSource = true;
      });

      video.dataset.videoActivated = 'true';

      if (hasDeferredSource) {
        try { video.load(); } catch (e) {}
      }
    }

    function bindVideoLoad(video, card) {
      if (!video) return;
      const onReady = () => {
        video.classList.add('is-loaded');
        markCardReady(card);
      };
      if (video.readyState >= 2) {
        onReady();
        return;
      }
      video.addEventListener('loadeddata', onReady, { once: true });
      video.addEventListener('canplay', onReady, { once: true });
      video.addEventListener('error', onReady, { once: true });
    }

    function bindExternalVideoLoad(slide, card) {
      if (!slide) return false;
      const wrapper = slide.querySelector('.pc-media-external-video');
      if (!wrapper) return false;

      const iframe = wrapper.querySelector('iframe');
      if (iframe && !iframe.dataset.boundReady) {
        iframe.dataset.boundReady = 'true';
        iframe.setAttribute('loading', 'lazy');
        iframe.addEventListener('load', () => {
          wrapper.classList.add('is-loaded');
          markCardReady(card);
        }, { once: true });
      }

      if (iframe && iframe.dataset.src && iframe.dataset.externalActivated !== 'true') {
        iframe.dataset.externalActivated = 'true';
        iframe.setAttribute('src', iframe.dataset.src);
      }

      if (wrapper.dataset.readyFallbackBound !== 'true') {
        wrapper.dataset.readyFallbackBound = 'true';
        setTimeout(() => {
          wrapper.classList.add('is-loaded');
          markCardReady(card);
        }, 1500);
      }
      return true;
    }

    function ensureSlideMediaLoaded(slide, card) {
      if (!slide) return;
      const targetCard = card || slide.closest('.product-card__media-bg-wrapper');
      const img = slide.querySelector('img.pc-media-img');
      if (img) {
        if (img.dataset.src && img.dataset.loaded !== 'true') {
          img.dataset.loaded = 'true';
          if (img.dataset.srcset) img.srcset = img.dataset.srcset;
          if (img.dataset.sizes) img.sizes = img.dataset.sizes;
          img.src = img.dataset.src;
        }
        bindImageLoad(img, targetCard);
      }

      const video = slide.querySelector('video.pc-media-video');
      if (video) {
        activateDeferredVideo(video);
        bindVideoLoad(video, targetCard);
        if (video.preload === 'none') {
          const nextPreload = video.dataset.preload || 'metadata';
          video.preload = nextPreload;
          try { video.load(); } catch (e) {}
        }
      }

      if (slide.querySelector('.pc-media-external-video')) {
        bindExternalVideoLoad(slide, targetCard);
      }
    }

    function preloadAdjacentSlides(track, activeIndex) {
      if (!track) return;
      const nextSlide = track.children[activeIndex + 1];
      if (isSmallViewport()) {
        return;
      }
      if (nextSlide) ensureSlideMediaLoaded(nextSlide);
    }

    function observePrimaryMedia(card) {
      if (!card || card.dataset.primaryObserved === 'true') return;
      card.dataset.primaryObserved = 'true';
      const primarySlide = card.querySelector('.pc-carousel-slide.is-primary') || card.querySelector('.pc-carousel-slide');
      if (!primarySlide) {
        markCardReady(card);
        return;
      }
      ensureSlideMediaLoaded(primarySlide, card);
      const img = primarySlide.querySelector('img.pc-media-img');
      const video = primarySlide.querySelector('video.pc-media-video');
      if (img) {
        bindImageLoad(img, card);
      } else if (video) {
        bindVideoLoad(video, card);
      } else if (bindExternalVideoLoad(primarySlide, card)) {
        // handled by external video loader
      } else {
        markCardReady(card);
      }

      setTimeout(() => {
        markCardReady(card);
      }, 5000);
    }

    function playVideo(slide) {
      if (!slide) return;
      ensureSlideMediaLoaded(slide);
      const video = slide.querySelector('video');
      if (video) {
        video.muted = true;
        video.playsInline = true;
        
        if (video.readyState < 2) { 
           video.addEventListener('loadeddata', function onLoaded() {
             video.play().catch(function(){});
             video.removeEventListener('loadeddata', onLoaded);
           }, { once: true });
        }
        
        if (video.paused) {
          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.catch(function(){});
          }
        }
      }
    }

    function pauseVideo(slide) {
      if (!slide) return;
      const video = slide.querySelector('video');
      if (video && !video.paused) {
        video.pause();
      }
    }

    function scrollToSlide(track, slide, options = {}) {
      if (!track || !slide) return;
      const targetLeft = slide.offsetLeft;
      const immediate = !!options.immediate;
      ensureSlideMediaLoaded(slide);
      const activeIndex = Array.prototype.indexOf.call(track.children, slide);
      if (activeIndex > -1) preloadAdjacentSlides(track, activeIndex);
      window.requestAnimationFrame(() => {
        if (immediate) {
          scrollTrackInstant(track, targetLeft);
        } else {
          try { track.scrollTo({ left: targetLeft, behavior: 'smooth' }); } catch (e) { track.scrollLeft = targetLeft; }
        }
        playVideo(slide);
      });
    }

    function getPrimarySlide(track) {
      if (!track) return null;
      return track.querySelector('.pc-carousel-slide.is-primary') || track.children[0] || null;
    }

    function syncTrackToPrimary(track) {
      if (!track || track.dataset.initialSlideSynced === 'true') return;
      const primarySlide = getPrimarySlide(track);
      if (!primarySlide) {
        track.dataset.initialSlideSynced = 'true';
        return;
      }
      const primaryIndex = Array.prototype.indexOf.call(track.children, primarySlide);
      if (primaryIndex < 0) {
        track.dataset.initialSlideSynced = 'true';
        return;
      }

      ensureSlideMediaLoaded(primarySlide);

      const targetLeft = primarySlide.offsetLeft || 0;
      if (Math.abs(track.scrollLeft - targetLeft) > 1) {
        scrollTrackInstant(track, targetLeft);
      }
      track.dataset.activeIndex = String(primaryIndex);
      track.dataset.initialSlideSynced = 'true';
    }

    function getTrackState(track) {
      if (!track) return null;
      const cached = track._pcTrackState;
      if (cached && cached.slideCount === track.children.length) {
        return cached;
      }

      const container = track.closest('.pc-carousel-container');
      if (!container) return null;

      const indicatorsTrack = container.querySelector('.pc-segmented-indicators-track');
      const mask = container.querySelector('.pc-segmented-indicators-mask');
      const segments = indicatorsTrack ? Array.from(indicatorsTrack.querySelectorAll('.pc-indicator-segment')) : [];
      const state = { container, indicatorsTrack, mask, segments, slideCount: track.children.length };
      track._pcTrackState = state;
      return state;
    }

    function updateSegmentedIndicator(track, forceUpdate, options = {}) {
      if (!track || track.children.length === 0) return;
      const state = getTrackState(track);
      if (!state || !state.indicatorsTrack) return;

      const clientWidth = track.clientWidth;
      if (!clientWidth) return;

      const maxIndex = Math.max(track.children.length - 1, 0);
      const scrollLeft = track.scrollLeft;
      const activeIndex = Math.min(Math.max(Math.round(scrollLeft / clientWidth), 0), maxIndex);
      const activeSlide = track.children[activeIndex];
      ensureSlideMediaLoaded(activeSlide);
      if (!options.skipAdjacentPreload) {
        preloadAdjacentSlides(track, activeIndex);
      }

      const previousIndex = parseInt(track.dataset.activeIndex || '-1', 10);
      if (!forceUpdate && previousIndex === activeIndex) {
        return;
      }
      track.dataset.activeIndex = String(activeIndex);

      state.segments.forEach((segment, index) => {
        const slide = track.children[index];
        if (index === activeIndex) {
          segment.classList.add('active');
          playVideo(slide);
        } else {
          segment.classList.remove('active');
          pauseVideo(slide);
        }
      });

      if (state.mask) {
        const activeSegment = state.segments[activeIndex];
        if (activeSegment) {
          const maskWidth = state.mask.clientWidth;
          const trackWidth = state.indicatorsTrack.scrollWidth;
          const activeSegmentCenter = activeSegment.offsetLeft + (activeSegment.offsetWidth / 2);
          const maskCenter = maskWidth / 2;
          let moveX = activeSegmentCenter - maskCenter;
          if (moveX < 0) moveX = 0;
          const maxMove = Math.max(trackWidth - maskWidth, 0);
          if (moveX > maxMove) moveX = maxMove;
          state.indicatorsTrack.style.transform = `translateX(-${moveX}px)`;
        }
      }
    }

    /* --- Scroll Animation Logic --- */
    function initScrollAnimations(root) {
      // is-back-navigationクラスがある場合は即座にリターン（監視もしない）
      if (document.documentElement.classList.contains('is-back-navigation')) {
        collect(root, CARD_SELECTOR).forEach(card => markCardReady(card));
        return;
      }

      const targets = collect(root, SCROLL_TARGET_SELECTOR);
      if (targets.length === 0) return;

      if (!('IntersectionObserver' in window)) {
        targets.forEach((target) => {
          target.classList.add('is-visible');
          const track = target.querySelector(TRACK_SELECTOR);
          if (track) {
            setupCarousel(track);
          }
        });
        return;
      }

      if (!scrollObserver) {
        scrollObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            const target = entry.target;
            window.requestAnimationFrame(() => {
              target.classList.add('is-visible');
            });
            const track = target.querySelector(TRACK_SELECTOR);
            if (track) {
              setupCarousel(track);
            }
            scrollObserver.unobserve(target);
          });
        }, {
          root: null,
          rootMargin: '0px 0px -50px 0px',
          threshold: 0.1
        });
      }

      targets.forEach(target => scrollObserver.observe(target));
    }

    function initMediaObservers(root) {
      const cards = collect(root, CARD_SELECTOR);
      if (cards.length === 0) return;

      const eagerCardCount = window.matchMedia && window.matchMedia('(min-width: 990px)').matches ? 2 : 1;

      if (!('IntersectionObserver' in window)) {
        cards.forEach(card => {
          observePrimaryMedia(card);
          const track = card.querySelector(TRACK_SELECTOR);
          if (track && track.children.length > 0) {
            const primarySlide = getPrimarySlide(track);
            if (primarySlide) ensureSlideMediaLoaded(primarySlide, card);
          }
          card.dataset.mediaObserverAttached = 'true';
        });
        return;
      }

      if (!mediaObserver) {
        mediaObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            const card = entry.target;
            observePrimaryMedia(card);
            const track = card.querySelector(TRACK_SELECTOR);
            if (track && track.children.length > 0) {
              const primarySlide = getPrimarySlide(track);
              if (primarySlide) ensureSlideMediaLoaded(primarySlide, card);
            }
            mediaObserver.unobserve(card);
          });
        }, { rootMargin: '240px 0px' });
      }

      cards.forEach((card, idx) => {
        if (card.dataset.mediaObserverAttached === 'true') return;
        card.dataset.mediaObserverAttached = 'true';
        if (idx < eagerCardCount) {
          observePrimaryMedia(card);
          const track = card.querySelector(TRACK_SELECTOR);
          if (track && track.children.length > 0) {
            const primarySlide = getPrimarySlide(track);
            if (primarySlide) ensureSlideMediaLoaded(primarySlide, card);
          }
        } else {
          mediaObserver.observe(card);
        }
      });
    }

    function bindGlobalResize() {
      if (resizeBound) return;
      resizeBound = true;
      window.addEventListener('resize', () => {
        if (resizeTicking) return;
        resizeTicking = true;
        window.requestAnimationFrame(() => {
          activeTracks.forEach((track) => {
            if (!track.isConnected) {
              activeTracks.delete(track);
              return;
            }
            // 幅が変わるとスライド位置がずれるので、選択中のスライドに合わせ直してから更新
            resyncTrack(track);
            updateSegmentedIndicator(track, true);
          });
          resizeTicking = false;
        });
      }, { passive: true });
    }

    function setupCarousel(track) {
      if (!track || track.dataset.carouselInitialized === "true") return;
      if (carouselInitObserver) {
        try { carouselInitObserver.unobserve(track); } catch (e) {}
      }
      track.dataset.carouselInitialized = "true";
      track.dataset.carouselPending = "false";
      activeTracks.add(track);
      bindGlobalResize();
      syncTrackToPrimary(track);

      updateSegmentedIndicator(track, true, { skipAdjacentPreload: true });

      if ('IntersectionObserver' in window) {
        if (!carouselVisibilityObserver) {
          carouselVisibilityObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              const targetTrack = entry.target;
              if (entry.isIntersecting) {
                updateSegmentedIndicator(targetTrack, true);
              } else {
                targetTrack.querySelectorAll('video').forEach(v => v.pause());
              }
            });
          }, { threshold: 0.1 });
        }
        carouselVisibilityObserver.observe(track);
      }

      let ticking = false;
      track.addEventListener('scroll', function() {
        if (!ticking) {
          window.requestAnimationFrame(function() {
            updateSegmentedIndicator(track, false);
            ticking = false;
          });
          ticking = true;
        }
      }, { passive: true });
    }

    function initCarousels(root) {
      const tracks = collect(root, TRACK_SELECTOR);
      if (tracks.length === 0) return;

      const eagerTrackCount = window.matchMedia && window.matchMedia('(min-width: 990px)').matches ? 2 : 1;
      const canObserve = 'IntersectionObserver' in window;

      if (canObserve && !carouselInitObserver) {
        carouselInitObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const targetTrack = entry.target;
            carouselInitObserver.unobserve(targetTrack);
            setupCarousel(targetTrack);
          });
        }, { rootMargin: '260px 0px', threshold: 0.01 });
      }

      tracks.forEach((track, idx) => {
        if (track.dataset.carouselInitialized === "true") return;

        if (!canObserve || idx < eagerTrackCount) {
          setupCarousel(track);
          return;
        }

        if (track.dataset.carouselPending === "true") return;
        track.dataset.carouselPending = "true";
        carouselInitObserver.observe(track);
      });
    }

    function initClickBlockers(root) {
      const blockers = collect(root, CLICK_BLOCKER_SELECTOR);
      blockers.forEach(blocker => {
        if (blocker.dataset.blockerInitialized === "true") return;
        blocker.dataset.blockerInitialized = "true";
        blocker.addEventListener('click', (e) => { e.stopPropagation(); });
      });
    }

    function initSwatchListeners(root) {
      const cards = collect(root, CARD_SELECTOR);
      cards.forEach(card => {
        if (card.dataset.swatchListenerInitialized === "true") return;
        try {
          const variantMediaScript = card.querySelector('[data-product-variant-media-map]');
          const swatchWrapper = card.querySelector('.product-card__swatches-wrapper');
          if (!swatchWrapper) return;
          card.dataset.swatchListenerInitialized = "true";
          let variantMediaMap = null;

          const getVariantMediaMap = () => {
            if (variantMediaMap !== null) return variantMediaMap;
            if (!variantMediaScript) {
              variantMediaMap = [];
              return variantMediaMap;
            }
            try {
              const parsed = JSON.parse(variantMediaScript.textContent);
              variantMediaMap = Array.isArray(parsed) ? parsed : [];
            } catch (e) {
              variantMediaMap = [];
            }
            return variantMediaMap;
          };
          
          const handleSwitch = (rawSelectedValue, options = {}) => {
            if (!rawSelectedValue) return;
            const track = card.querySelector(TRACK_SELECTOR);
            if (!track) return;
            const targetValue = normalize(rawSelectedValue);
            let targetSlide = null;

            const mediaMap = getVariantMediaMap();
            const mappedMedia = mediaMap.find(item => normalize(item.value) === targetValue);
            if (mappedMedia && mappedMedia.media_id) {
              targetSlide = track.querySelector(`.pc-carousel-slide[data-media-id="${mappedMedia.media_id}"]`);
            }
            if (!targetSlide) {
              const slides = Array.from(track.querySelectorAll('.pc-carousel-slide'));
              targetSlide = slides.find(slide => normalize(slide.dataset.mediaAlt) === targetValue);
              if (!targetSlide) {
                targetSlide = slides.find(slide => normalize(slide.dataset.mediaAlt).includes(targetValue));
              }
            }
            if (targetSlide) scrollToSlide(track, targetSlide, options);

            // 選択した色のバリアントをカードのリンク先に反映（商品ページで同じ色が開く）
            if (mappedMedia && mappedMedia.variant_id) {
              const productCard = card.closest('product-card');
              const cardLink = productCard ? productCard.querySelector('a.product-card__link') : null;
              if (cardLink && cardLink.getAttribute('href')) {
                try {
                  const linkUrl = new URL(cardLink.getAttribute('href'), window.location.href);
                  linkUrl.searchParams.set('variant', String(mappedMedia.variant_id));
                  cardLink.setAttribute('href', linkUrl.pathname + linkUrl.search + linkUrl.hash);
                } catch (e) {}
              }
              const transitionCard = card.closest('.pc-product-card-transition');
              if (transitionCard && transitionCard.dataset.productUrl) {
                try {
                  const cardUrl = new URL(transitionCard.dataset.productUrl, window.location.href);
                  cardUrl.searchParams.set('variant', String(mappedMedia.variant_id));
                  transitionCard.dataset.productUrl = cardUrl.pathname + cardUrl.search + cardUrl.hash;
                } catch (e) {}
              }
            }
          };

          swatchWrapper.addEventListener('change', (event) => {
            if (event.target.matches('input[type="radio"]')) handleSwitch(event.target.dataset.rawValue || event.target.value);
          });
          swatchWrapper.addEventListener('click', (event) => {
            const label = event.target.closest('.pc-swatch-label');
            if (!label) return;
            const item = label.closest('.pc-swatch-item');
            if (!item) return;
            const input = item.querySelector('input.pc-swatch-input');
            if (input) {
              setTimeout(() => {
                input.checked = true;
                handleSwitch(input.dataset.rawValue || input.value);
              }, 0);
            }
          });

          const initiallyChecked = swatchWrapper.querySelector('input.pc-swatch-input:checked');
          const firstInStock = swatchWrapper.querySelector('.pc-swatch-item:not(.is-sold-out) input.pc-swatch-input');
          const fallbackInput = swatchWrapper.querySelector('input.pc-swatch-input');
          const initialInput = initiallyChecked || firstInStock || fallbackInput;
          if (initialInput) {
            initialInput.checked = true;
            handleSwitch(initialInput.dataset.rawValue || initialInput.value, { immediate: true });
          }
        } catch (err) { console.error(err); }
      });
    }

    function shouldBypassCardNavigation(event) {
      const bypassSelectors = [
        'button',
        'input',
        'select',
        'textarea',
        'summary',
        'label',
        'form',
        '[role="button"]',
        '[contenteditable="true"]',
        '.pc-click-blocker',
        '.product-card__swatches-wrapper',
        '[data-no-page-transition]'
      ];

      const path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
      return path.some((node) => {
        if (!(node instanceof Element)) return false;
        return bypassSelectors.some((selector) => node.matches(selector));
      });
    }

    function initCardTransitionFallback(root) {
      const cards = collect(root, CARD_NAV_SELECTOR);
      cards.forEach((card) => {
        if (card.dataset.transitionFallbackInitialized === 'true') return;
        card.dataset.transitionFallbackInitialized = 'true';

        card.addEventListener('click', (event) => {
          if (event.__ohTransitionHandled === true) return;
          if (event.button !== 0) return;
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          if (shouldBypassCardNavigation(event)) return;

          const navigate = window.__ohPageTransitionNavigate;
          const nextUrl = card.dataset.productUrl;
          if (typeof navigate !== 'function' || !nextUrl) return;

          event.preventDefault();
          if (typeof event.stopImmediatePropagation === 'function') {
            event.stopImmediatePropagation();
          }
          event.stopPropagation();

          navigate(nextUrl, {
            title: card.dataset.productTitle || ''
          });
        }, true);
      });
    }

    // bfcache対策（再掲）
    window.addEventListener('pageshow', function(event) {
      if (event.persisted) {
        collect(document, '.pc-scroll-animate-target').forEach(el => {
           el.classList.add('is-visible');
        });
        collect(document, CARD_SELECTOR).forEach(card => markCardReady(card));
        // bfcache から復帰したときは、選択中のスライド位置を合わせ直してからインジケーターを更新
        collect(document, TRACK_SELECTOR).forEach(track => {
          resyncTrack(track);
          updateSegmentedIndicator(track, true);
        });
      }
    });

    function initAll(root) {
      initScrollAnimations(root);
      initMediaObservers(root);
      initCarousels(root);
      initClickBlockers(root);
      initSwatchListeners(root);
      initCardTransitionFallback(root);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => queueInit(document), { once: true });
    } else {
      queueInit(document);
    }
    window.addEventListener('load', () => queueInit(document), { once: true });

    document.addEventListener('shopify:section:load', (event) => {
      queueInit(event.target || document);
    });
    document.addEventListener('shopify:section:reorder', (event) => {
      queueInit(event.target || document);
    });
    document.addEventListener('shopify:block:select', (event) => {
      queueInit(event.target || document);
    });

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (hasReinitTarget(node)) {
            queueInit(node);
          }
        });
      });
    });
    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const modal = document.querySelector('[data-contact-success-modal]');
    if (!modal) return;

    const closeModal = () => {
      modal.classList.remove('is-open');
      document.documentElement.classList.remove('contact-success-modal-open');
      document.body.classList.remove('contact-success-modal-open');
    };

    document.documentElement.classList.add('contact-success-modal-open');
    document.body.classList.add('contact-success-modal-open');

    modal.querySelectorAll('[data-contact-success-close]').forEach((el) => {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeModal();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
